import React, { FunctionComponent } from 'react'

const MauticTrialForm: FunctionComponent = () => <></>

export default MauticTrialForm
